import React from "react";
import {
    BottomButton,
    BottomSection,
    ContentCard,
    ContentSection,
    TabContentWrapper,
} from "./styles";

/**
 * Content skeleton shown when switching tabs (API loading)
 */
export const TabContentLoadingSkeleton: React.FC = () => {
    return (
        <TabContentWrapper>
            <ContentSection>
                <ContentCard />
                <ContentCard />
            </ContentSection>

            <BottomSection>
                <BottomButton />
            </BottomSection>
        </TabContentWrapper>
    );
};
